import { KeyRelationship, Note } from "../../../Data/HexMap/Note";
import { Music } from "../../../Util/Music/Music";
import { ChapterConfig } from "../../ChapterConfig";
import { OutlineBox } from "../../../Comps/OutlineBox/OutlineBox";
import { ChapterNav, ChapterNavItem } from "../ChapterNav/ChapterNav";
import { ChapterRoutes } from "../ChapterNav/ChapterRoutes";
import { ClearHelpers } from "../../Helpers/ClearHelpers/ClearHelpers";
import { HxMapGroup } from "../../../Comps/HxMap/HxMapGroup";
import { BuildHexMap} from "../../../Data/HexMap/HexMapBuilder";
import { HexMap } from "../../../Data/HexMap/HexMap";
import { TransformTranslate } from "../../../Util/Transform/Transform";
import { HexMapModifier } from "../../../Data/HexMap/HexMapModifier";
import { All } from "../../../Util/Constants/Quantities";
import { useState } from "react";
import { NoteLine } from "../../../Comps/Connectors/NoteLine";
import './Intro.scss'
import { DotNav } from "../../../Comps/DotNav/DotNav";

export function Intro(props:ChapterConfig){
    const subPaths:ChapterNavItem[] = [
        {title:'Lesson', path:'lesson', element:<ClearHelpers><Lesson/></ClearHelpers>}
    ]
    return  <div className={'intro-chapter'}>
                <h1>The HexKey System</h1>
                <ChapterNav path={props.path} subPaths={subPaths}/>
                <ChapterRoutes chapterNavs={subPaths}/>
            </div>
}

export function Lesson(){
    const radius:number = 50
    const width:number = 850
    const height:number = 500
    const tonic:number = Music.E
    const [screenIndex, setScreenIndex] = useState(0)
    const centerKey:number = 34
    const getMap = () => {  
        const hexMap:HexMap = BuildHexMap({columns:10, rows:8, tonic:tonic, radius:radius})
        const centerNotes:number[] = hexMap.keys.flat()[centerKey].noteIndexes
        const innerKeys:number[] = [23,24,25,26,33,35,36,44,45,46,47]
        const outerNotes:number[] = []
        hexMap.notes.forEach((note:Note)=>{
            if(!centerNotes.includes(note.params.noteIndex)){
                const matchingKeys:KeyRelationship[] = note.keys.filter((k:KeyRelationship)=>{
                    return(innerKeys.includes(k.keyIndex))
                })
                if(matchingKeys.length === 0){
                    outerNotes.push(note.params.noteIndex)
                }
            }
        })
        const mod:HexMapModifier = new HexMapModifier(hexMap)
        mod.notes_setDefined(outerNotes, false)
        mod.keys_setOpen([All], false)
        mod.keys_setVisible([All], false)
        mod.keys_setVisible([centerKey], true)
        mod.keys_setOpen([centerKey], true) 
        mod.keys_setSelected([centerKey])
        mod.notes_setSelected(centerNotes)
        if(screenIndex >= 1){
        }
        if(screenIndex >= 2){
            mod.keys_setVisible([All], true)
            mod.keys_addClasses([All], ['ghosted']) 
            mod.keys_removeClasses(innerKeys.concat([centerKey]), ['ghosted']) 
            mod.keys_setVisible([All], true)
            mod.keys_setOpen(innerKeys.concat([centerKey]), true)
            mod.notes_setVisible([All], true)
            mod.notes_addClasses(outerNotes, ['ghosted'])
        }


        return hexMap
    }
    const getScale = () => {
        switch (screenIndex) {
            case 0:
                return 2.5 
            case 1:       
                return 2.5
            case 2:
                return 1.5 
            default:
                return 1
        }
    }
    const onDotNavClick = (index:number) => {
        setScreenIndex(index)
    }
    const map:HexMap = getMap()
    const getNoteLines = () => {
        if(screenIndex !== 1 ){return null}
        const noteLines:JSX.Element[] = []
        const centerNotes:number[] = map.keys.flat()[centerKey].noteIndexes
        for(let i = 0; i < centerNotes.length; i++){
            for( let j = i + 1; j < centerNotes.length; j++){
                noteLines.push(
                    <NoteLine key={i*100+j} animate={true} delay={0.15} startNote={map.notes[centerNotes[i]]} endNote={map.notes[centerNotes[j]]} displayConfig={map.params.displayConfig}/>
                )
            }
        }
        return noteLines

    }
    return(
        <OutlineBox title={'The HexKey System - Musical Geometry'} width={width}>
            <div style={{overflow:'hidden'}}>
                <div className={'Lesson'} style={{overflow:'hidden'}}>
                    <svg width={width} height={height}>
                        <g transform={TransformTranslate(width/2, (height/2) + (getScale() * radius))}>
                            <g className={'scale-container'} style={{scale:getScale()}}>
                                <HxMapGroup hexMap={map}>
                                    {getNoteLines()}
                                </HxMapGroup>
                            </g>
                        </g>
                    </svg>
                </div>
                
            </div>
            <div>
                <DotNav length={3} selectedIndex={screenIndex} onClick={onDotNavClick}/>
            </div>
        </OutlineBox>
    )
}

